import type { IconName } from "@fortawesome/pro-regular-svg-icons";
import {
  faArrowDownFromBracket,
  faArrowsRotate,
  faBullhorn,
  faCalendar,
  faCheck,
  faChevronDown,
  faChevronUp,
  faCircleInfo,
  faCirclePlus as faCirclePlusRegular,
  faCog,
  faColumns3,
  faCommentDots,
  faComments,
  faCopy,
  faEdit,
  faEye,
  faFloppyDisk,
  faImage,
  faList,
  faLock,
  faLockOpen,
  faPen,
  faPenToSquare,
  faPhone,
  faPhoneArrowUpRight,
  faPhoneXmark,
  faRotateLeft,
  faSlidersSimple,
  faSmile,
  faThumbtack,
  faTrash,
  faUndo,
  faUser,
  faVideo,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faArrowLeft,
  faArrowRight,
  faArrowRightToLine,
  faBoxArchive,
  faCircleCheck,
  faCirclePlus,
  faMessages,
  faPaperPlane,
  faPlus,
  faThumbtack as faThumbtackSolid,
  faUserPlus,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

import { BankIdLogo } from "assets";
import type { Size } from "shared/atoms/BaseButton/BaseButton";
import { RED } from "theme/colors";

export const getIcon = (icon?: IconName | "bankid" | "circle-plus-regular" | "thumbtack-solid", size?: Size) => {
  const iconSize = size === "small" ? 14 : 16;
  const iconStyles = {
    height: `${iconSize}px`,
    width: `${iconSize}px`,
  };

  switch (icon) {
    case "arrow-down-from-bracket":
      return <FontAwesomeIcon icon={faArrowDownFromBracket} style={iconStyles} />;
    case "arrow-left":
      return <FontAwesomeIcon icon={faArrowLeft} style={iconStyles} />;
    case "arrow-right":
      return <FontAwesomeIcon icon={faArrowRight} style={iconStyles} />;
    case "arrow-right-to-line":
      return <FontAwesomeIcon icon={faArrowRightToLine} style={iconStyles} />;
    case "arrows-rotate":
      return <FontAwesomeIcon icon={faArrowsRotate} style={iconStyles} />;
    case "bankid":
      return <StyledBankIdLogo style={{ fill: "#fff" }} />;
    case "box-archive":
      return <FontAwesomeIcon icon={faBoxArchive} style={iconStyles} />;
    case "bullhorn":
      return <FontAwesomeIcon icon={faBullhorn} style={iconStyles} />;
    case "calendar":
      return <FontAwesomeIcon icon={faCalendar} style={iconStyles} />;
    case "check":
      return <FontAwesomeIcon icon={faCheck} style={iconStyles} />;
    case "chevron-down":
      return <FontAwesomeIcon icon={faChevronDown} style={iconStyles} />;
    case "chevron-up":
      return <FontAwesomeIcon icon={faChevronUp} style={iconStyles} />;
    case "circle-check":
      return <FontAwesomeIcon icon={faCircleCheck} style={iconStyles} />;
    case "circle-info":
      return <FontAwesomeIcon icon={faCircleInfo} style={iconStyles} />;
    case "circle-plus":
      return <FontAwesomeIcon icon={faCirclePlus} color="#5096E8" style={{ height: "20px", width: "20px" }} />;
    case "circle-plus-regular":
      return <FontAwesomeIcon icon={faCirclePlusRegular} style={iconStyles} />;
    case "cog":
      return <FontAwesomeIcon icon={faCog} style={iconStyles} />;
    case "columns-3":
      return <FontAwesomeIcon icon={faColumns3} style={iconStyles} />;
    case "comment-dots":
      return <FontAwesomeIcon icon={faCommentDots} style={iconStyles} />;
    case "comments":
      return <FontAwesomeIcon icon={faComments} style={iconStyles} />;
    case "copy":
      return <FontAwesomeIcon icon={faCopy} style={iconStyles} />;
    case "edit":
      return <FontAwesomeIcon icon={faEdit} style={iconStyles} />;
    case "eye":
      return <FontAwesomeIcon icon={faEye} style={iconStyles} />;
    case "floppy-disk":
      return <FontAwesomeIcon icon={faFloppyDisk} style={iconStyles} />;
    case "image":
      return <FontAwesomeIcon icon={faImage} style={iconStyles} />;
    case "list":
      return <FontAwesomeIcon icon={faList} style={iconStyles} />;
    case "lock":
      return <FontAwesomeIcon icon={faLock} style={iconStyles} />;
    case "lock-open":
      return <FontAwesomeIcon icon={faLockOpen} style={iconStyles} />;
    case "messages":
      return <FontAwesomeIcon icon={faMessages} style={iconStyles} />;
    case "paper-plane":
      return <FontAwesomeIcon icon={faPaperPlane} style={iconStyles} />;
    case "pen":
      return <FontAwesomeIcon icon={faPen} style={iconStyles} />;
    case "pen-to-square":
      return <FontAwesomeIcon icon={faPenToSquare} style={iconStyles} />;
    case "phone":
      return <FontAwesomeIcon icon={faPhone} style={iconStyles} />;
    case "phone-arrow-up-right":
      return <FontAwesomeIcon icon={faPhoneArrowUpRight} style={iconStyles} />;
    case "phone-xmark":
      return <FontAwesomeIcon icon={faPhoneXmark} style={iconStyles} />;
    case "plus":
      return <FontAwesomeIcon icon={faPlus} style={iconStyles} />;
    case "rotate-left":
      return <FontAwesomeIcon icon={faRotateLeft} style={iconStyles} />;
    case "sliders-simple":
      return <FontAwesomeIcon icon={faSlidersSimple} style={iconStyles} />;
    case "smile":
      return <FontAwesomeIcon icon={faSmile} style={iconStyles} />;
    case "thumbtack":
      return <FontAwesomeIcon icon={faThumbtack} style={iconStyles} />;
    case "thumbtack-solid":
      return <FontAwesomeIcon icon={faThumbtackSolid} style={iconStyles} />;
    case "trash":
      return <FontAwesomeIcon icon={faTrash} color={RED[100]} style={iconStyles} />;
    case "xmark":
      return <FontAwesomeIcon icon={faXmark} color={RED[100]} style={iconStyles} />;
    case "undo":
      return <FontAwesomeIcon icon={faUndo} style={iconStyles} />;
    case "user":
      return <FontAwesomeIcon icon={faUser} style={iconStyles} />;
    case "video":
      return <FontAwesomeIcon icon={faVideo} style={iconStyles} />;
    case "user-plus":
      return <FontAwesomeIcon icon={faUserPlus} />;
    default:
      return null;
  }
};

const StyledBankIdLogo = styled(BankIdLogo)`
  * {
    fill: #fff;
  }
`;
